import { createSelector } from 'reselect';
import { freeReturnsOnBasketSelector } from 'selectors/testTarget/offers/freeReturnsOnBasket/freeReturnsOnBasketSelector';

const showSelector = createSelector(freeReturnsOnBasketSelector, freeReturnsOnBasket => !!freeReturnsOnBasket.show);

export { showSelector };
